var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNoImg = function SvgNoImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 156,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EBF2",
    d: "M0 0h251v156H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.253 87.026l-7.737-11.893c-1.633-2.508-4.449-2.614-6.266-.25l-5.587 7.253c-1.825 2.368-4.792 2.357-6.599-.01l-2.877-3.768c-1.804-2.372-4.757-2.372-6.557.011l-6.728 8.878c-1.802 2.382-.819 4.324 2.182 4.324h37.675c3 0 4.122-2.047 2.494-4.545zM122.386 69.345c3.436 0 6.226-2.77 6.226-6.17 0-3.411-2.79-6.175-6.226-6.175-3.432 0-6.22 2.764-6.22 6.175-.001 3.4 2.788 6.17 6.22 6.17z",
    fill: "rgba(0, 0, 0, 0.87)",
    fillOpacity: 0.5
  })));
};
export default __webpack_public_path__ + "static/media/noIMG.74b1ef7e.svg";
export { SvgNoImg as ReactComponent };